<template>
  <!-- 导航栏-->
  <div class="main">
    <div class="nav-wrap">
      <div class="nav-box">
        <div class="nav-div">
          <div class="nav-left" v-if="isSaasProxyUser === 0 || isDyAppOwner === 1">
            <div class="logo">
              <img src="../assets/img/home_logo.png" alt="logo" @click="linkTo(0)">
            </div>
          </div>
          <div v-else class="top-logo-nav">
            <img style="margin-left: 40px" src="../assets/img/logoProxy.png" alt="">
            <div class="logo-text">好影影票</div>
          </div>
          <div class="nav-right">
            <div class="nav-title" v-if="isSaasProxyUser === 1 && isDyAppOwner === 0"><span
                :class="(activeIndex == 0 || activeIndex == 4) ? 'active' : ''" @click="linkToDouyin()">电影票</span></div>
            <div class="nav-title" v-if="isSaasProxyUser === 1 && isDyAppOwner === 0"><span class="active">账户中心</span>
            </div>
            <div class="navbar-nav" v-else>
              <div class="navbar-nav-div"><span :class="(activeIndex == 0 || activeIndex == 4) ? 'active' : ''"
                  @click="linkTo(0)">电影票</span></div>
              <div class="navbar-nav-div" v-if="isSaas == 1"><span :class="(activeIndex == 7) ? 'active' : ''"
                  @click="linkTo(7)">Saas加盟</span></div>
              <!--              <div class="navbar-nav-div"><span :class="(activeIndex == 1) ? 'active':''" @click="linkTo(1)">我要推广</span></div>-->
              <!--              <div class="navbar-nav-div"><span :class="(activeIndex == 5) ? 'active':''" @click="linkTo(5)">公众号入驻</span></div>-->
              <!--              <div class="navbar-nav-div"><span :class="(activeIndex == 6) ? 'active':''" @click="linkTo(6)">肯德基</span></div>-->
<!--              <div class="navbar-nav-div"><span :class="(activeIndex == 8) ? 'active' : ''" @click="linkTo(8)">品牌商城</span>-->
<!--              </div>-->
              <div class="navbar-nav-div"><span :class="(activeIndex == 88) ? 'active' : ''"
                  @click="linkTo(88)">账户中心</span>
              </div>

              <!-- <div class="navbar-nav-div"><span :class="(activeIndex == 9) ? 'active':''" @click="linkTo(9)">账户中心</span></div> -->
              <div class="navbar-nav-div" v-if="isShowOpen"><span :class="(activeIndex == 2) ? 'active' : ''"
                  @click="linkTo(2)">开放平台</span></div>
              <div class="navbar-nav-div"><span :class="(activeIndex == 3 && isShowContact == true) ? 'active' : ''"
                  @click="linkTo(3)">联系我们</span></div>
            </div>
            <contact v-show="isShowContact"></contact>
          </div>
        </div>
        <!--        <div class="button-register" v-show="!$store.getters.userToken">-->
        <!--                <span :class="(activeIndex == 4) ? 'active register':'register'" @click="linkTo(4)">注册-->
        <!--                </span>-->
        <!--        </div>-->
        <div class="user-info" v-if="$store.getters.userToken">
          <!-- <div v-if="!this.$store.state.isLogin">
            <span class="no-login-hint">您还未登录</span>
          </div> -->
          <div>
            <span class="mobile">{{ $store.getters.nickname }}</span>
            <span class="exit" @click="userExit">退出</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 导航栏-->
</template>

<script>
import navArrowDowm from '@/assets/img/official/nav_btn_arrow_down.png'
import navArrowUp from '@/assets/img/official/nav_btn_arrow_upward.png'
import { getToken, getUserInfo, getIsDeveloper } from '@/utils/auth'
import Contact from '@/components/Contact'
import { Modal } from 'view-design'
export default {
  name: 'Nav',
  components: {
    Contact,
    Modal,
    navArrowDowm,
    navArrowUp,
  },
  data: function () {
    return {
      isShowContact: false,
      needLoginIndex: [1, 2, 88, 7],
      userInfo: {},
      arrowIcon: navArrowDowm,
      isShow: false,
      isSaas: 0
    }
  },
  created() {
    if (this.$domain.indexOf('movie')!= -1 && this.isDyAppOwner!= 1) {
      this.$store.commit('user/SET_APP_TYPE', {
        isSaasProxyUser: 0,
        isDyAppOwner: this.isDyAppOwner
      })
    }

    this.userInfo = getUserInfo()
    this.isSaas = localStorage.getItem('isSaas')
  },
  computed: {
    activeIndex: function () {
      return this.$store.getters.activeIndex
    },
    isVisitor: function () {
      return this.$store.getters.userToken ? true : false
    },
    activeItem: function () {
      return this.$store.getters.personalActiveIndex
    },
    isShowOpen: function () {
      //不管是否登录 是否为开发者都显示
      return true
      if (!this.$store.getters.userToken) {
        return true
      } else {
        if (this.$store.getters.isDeveloper) {
          return true
        } else {
          return false
        }
      }
    },
    isSaasProxyUser: function () {
      return this.$store.getters.isSaasProxyUser
    },
    isDyAppOwner: function () {
      return this.$store.getters.isDyAppOwner
    },
  },
  methods: {
    linkTo: function (type) {
      var that = this
      var isNext = true
      let isSaas = window.localStorage.getItem('isSaas')
      if (this.needLoginIndex.indexOf(type) > -1) {
        var token = getToken()
        console.log('token', token)
        if (token === undefined || token === '') {
          isNext = false
          // 弹窗提示
          Modal.warning({
            title: '提示',
            content: '您还未登录，请先登录！',
            onOk: function () {
              that.$store.dispatch('nav/changeActiveIndex', 0)

              if (type == 7 && isSaas == 1) {
                that.$router.push({
                  path: '/',
                  query: {
                    type: 'saasmovie'
                  }
                })
              } else {
                that.$router.push('/')
              }
            }
          })
        }
      }

      if (isNext == false) {
        return
      }

      if (type === 3) {
        this.isShowContact = !this.isShowContact
      } else {
        this.isShowContact = false
        this.$store.dispatch('nav/changeActiveIndex', type)
        switch (type) {
          case 1:
            this.$router.push('/pc/promotion/home')
            break
          case 2:
            this.$router.push('/pc/document/user')
            break
          case 3:
            this.isShowContact = !this.isShowContact
            break
          case 4:
            this.$router.push('/pc/register')
            break
          case 5:
            this.$router.push('/pc/official/home')
            break
          case 6:
            if (isSaas == 1) {
              that.$router.push({
                path: '/pc/kfc/home',
                query: {
                  type: 'saasmovie'
                }
              })
            } else {
              that.$router.push({
                path: '/pc/kfc/home',
              })
            }
            break
          case 7:
            this.$router.push('/pc/SaasJoin/home/index')
            break
          case 8:
            if (isSaas == 1) {
              that.$router.push({
                path: '/pc/open/home',
                query: {
                  type: 'saasmovie'
                }
              })
            } else {
              that.$router.push({
                path: '/pc/open/home',
              })
            }
            break
          case 88:
            this.$router.push('/pc/user/accountWithdrawal')
            break
          case 0:
            // if(isSaas == 1){
            //   that.$router.push({
            //     path:'/',
            //     query:{
            //       type:'saasmovie'
            //     }
            //   })
            // }else {
            //   that.$router.push({
            //     path:'/',
            //   })
            // }
            if (this.isSaasProxyUser === 1 && this.isDyAppOwner === 0) {
              this.$router.push({
                path: '/pc/douyin/index',
              })
            } else {
              this.$router.push({
                path: '/',
              })
            }
            this.$store.dispatch('nav/changeMovieShowDialog', true)
            break
        }
      }
    },
    linkToDouyin() {
      var token = getToken()
      let that = this
      if (token === undefined || token === '') {
        // 弹窗提示
        Modal.warning({
          title: '提示',
          content: '您还未登录，请先登录！',
          onOk: function () {
            that.$store.dispatch('nav/changeActiveIndex', 0)
            this.$router.push({
              path: '/pc/proxyHome/index',
            })
          }
        })
      } else {
        this.$router.push({
          path: '/pc/douyin/home/index',
        })
        localStorage.setItem("isSelect", 0);
      }
      // let token = getToken()
      // console.log("debug:________________token______________", token);
      // if (token === undefined || token === '') {
      //   // 弹窗提示
      //   Modal.warning({
      //     title: '提示',
      //     content: '您还未登录，请先登录！',
      //     onOk: function () {
      //       this.$store.dispatch('nav/changeActiveIndex', 0)
      //       this.$router.push({
      //         path: '/pc/proxyHome/index',
      //       })
      //     }
      //   })
      // }else{
      //
      // }
    },
    userExit() {
      this.$store.dispatch('nav/changeIsGoOfficial', 0)
      this.$store.dispatch('user/logout')
      this.$Message.success('退出成功')
      if (this.isSaas == 1) {
        this.$router.push({
          path: '/',
          query: {
            type: 'saasmovie'
          }
        })
      } else {
        this.$router.push({
          path: '/',
        })
      }
      // 判断是否是代理分销的账户进到制定登录页
      if (this.isSaasProxyUser === 1 && this.isDyAppOwner === 0) {
        this.$router.push({
          path: '/pc/proxyHome/index',
        })
      } else {
        this.$router.push({
          path: '/',
        })
      }
    },
    changeArrow() {
      if (this.isShow === false) {
        this.isShow = true
        this.arrowIcon = navArrowUp
      } else {
        this.isShow = false
        this.arrowIcon = navArrowDowm
      }
    },
    //跳转到我的邀请
    toInvite(activeItem) {
      this.$store.dispatch('nav/changePersonalActiveIndex', activeItem)
      this.$router.push('/pc/official/invite')
    },
    //跳转到我的推广
    toPromote(activeItem) {
      this.$store.dispatch('nav/changePersonalActiveIndex', activeItem)
      this.$router.push('/pc/promotion/home')
    },
    //跳转到我的公众号
    toMyWechat(activeItem) {
      this.$store.dispatch('nav/changePersonalActiveIndex', activeItem)
      this.$router.push('/pc/official/mywechat')
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
}

.nav-wrap {
  height: 80px;
  background: #ffffff;
  position: relative;
}

.nav-wrap .nav-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* width: 60%; */
  /*margin: auto 13.5%;*/
  /* margin-right: 13.5%; */
  /* margin: 0 auto; */
  /* min-width: 850px; */
}

.nav-wrap .nav-box .nav-div {
  /* width: 100%; */
  height: 80px;
  /* min-width: 860px; */
  display: flex;
  flex-direction: row;
  /*justify-content: space-between;*/
  align-items: center;
}

.nav-wrap .nav-box .nav-div .nav-left {
  float: left;
  /*width: 178px;*/
}

.nav-wrap .nav-box .nav-div .nav-left .logo {
  width: 280px;
  height: 80px;
  background: #ff8622;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

.nav-wrap .nav-box .nav-div .nav-left .logo img {
  /* height: 58px; */
  width: 192px;
  height: 58px;
}

.nav-right {
  float: right;
  display: flex;

}

.nav-right .navbar-nav {
  float: right;
  /* font-family: Alibaba-PuHuiTi-R; */
  font-size: 16px;
  color: #666666;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
  text-align: center;
}

.nav-right .navbar-nav .navbar-nav-div {
  float: left;
  margin: 0 25px;
  /* min-width: 65px; */
  white-space: nowrap;
  font-size: 15px;
}

.nav-right .navbar-nav .navbar-nav-div:last-child {
  float: left;
  margin-right: 0;
  /* min-width: 65px; */
  white-space: nowrap;
}

.nav-right .navbar-nav .navbar-nav-div span {
  cursor: pointer;
}

.nav-right .navbar-nav .navbar-nav-div span.active {
  color: #ff9734;
}

.nav-right .navbar-nav .navbar-nav-div .register {
  color: #ff9734;
  border: 1px solid #ff9734;
  border-radius: 15px;
  padding: 4px 20px;
}

/* @media (min-width: 768px) {
    .nav-wrap .nav-box {
      width: 85%;
    }
  }

  @media (min-width: 992px) {
    .nav-wrap .nav-box {
      width: 80%;
    }
  }

  @media (min-width: 1200px) {
    .nav-wrap .nav-box {
      width: 70%;
    }
  }

  @media (min-width: 1400px) {
    .nav-wrap .nav-box {
      width: 62.5%;
    }
  } */

.mobile {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF8622;
  line-height: 20px;
}

.no-login-hint {
  font-size: 16px;
  color: #999;
}

.exit {
  margin-left: 10px;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 20px;
  cursor: pointer;
}

.navbar-nav-div .arrow-img {
  width: 20px;
}

.navbar-nav .navbar-nav-div .nav-dialog-box {
  background: #ffffff;
  width: 100px;
  position: relative;
  top: 0px;
  border-top: 1px solid #eeeeee;
  z-index: 999;
}

.navbar-nav .navbar-nav-div .nav-dialog-box span {
  width: 0;
  height: 0;
  font-size: 0;
  overflow: hidden;
  position: absolute;
}

.navbar-nav .navbar-nav-div .nav-dialog-box .bot {
  border-width: 8px;
  border-style: solid dashed dashed;
  border-color: transparent transparent #eeeeee transparent;
  left: 44%;
  top: -16px;
}

.navbar-nav .navbar-nav-div .nav-dialog-box .top {
  border-width: 8px;
  border-style: solid dashed dashed;
  border-color: transparent transparent #ffffff transparent;
  left: 44%;
  top: -15px;
}

.navbar-nav .navbar-nav-div .nav-dialog-box .nav-item {
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #666666;
  line-height: 36px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-top: none;
  z-index: 999;
}

.navbar-nav .navbar-nav-div .nav-dialog-box .nav-item div {
  height: 36px;
}

.navbar-nav .navbar-nav-div .nav-dialog-box .nav-item .active {
  background: #fcfaf8;
  color: #ff9734;
}

.button-register {
  width: 80px;
  height: 32px;
  border-radius: 18px;
  text-align: center;
  line-height: 32px;
  margin-right: 50px;
  cursor: pointer;
  background: #FF8622;
}

.button-register span {
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #ffffff;
  line-height: 22px;
}

.user-info {
  margin-right: 50px;
}

.nav-title {
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  margin-left: 40px;
  cursor: pointer;
}

.logo-text {
  font-size: 18px;
  font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #000000;
  line-height: 25px;
  margin-left: 10px;
}

.top-logo-nav {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue